services = require.context('.', true);
services.keys().forEach(services);
